import React, { useState } from "react";

import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reusable/Spinner";
import Skeleton from "../../components/Reusable/Skeleton";
const RiderSettingComponent = loadable(
  () => import("../../components/RiderSetting")
);
const RiderSetting = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState<any>([]);
  const handleEditStatusChange = (value: any) => {
    setDefaultValue(value);
  };

  const {
    data: gridData,
    refetch,
    isLoading,
  } = useGetHook({
    queryKey: [`grid-data-rider`],
    url: `${APIS.GRID_REPORT_DATA_COURIER}`,
    params: {
      parent__slug: "rider",
    },
  });

  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {
      is_active: true,
    },
  });

  const { mutateAsync, isLoading: patchLoading } = usePatchHook({
    queryKey: ["grid-data"],
    navigateURL: "",
  });

  const handleStatusInclude = async (event: any) => {
    event.preventDefault();
    const url = `${APIS.GRID_REPORT_DATA_COURIER}${selectedItem?.id}/`;
    let formData = {
      status: defaultValue?.map((item: any) => item.id) ?? [],
    };
    try {
      const rest = await mutateAsync({ url, formData });
      if (rest.status === 200) {
        setOpenEditPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleOpenEditPopup = (item: any) => {
    setSelectedItem(item);
    setDefaultValue(item?.status);
    setOpenEditPopup(true);
    // console.log(item, "status");
  };
  return (
    <div>
      {isLoading ? (
        <Skeleton limit={5} />
      ) : (
        <RiderSettingComponent
          refetch={refetch}
          gridData={gridData}
          statusList={statusList}
          patchLoading={patchLoading}
          handleStatusInclude={handleStatusInclude}
          setSelectedItem={setSelectedItem}
          setOpenEditPopup={setOpenEditPopup}
          openEditPopup={openEditPopup}
          handleEditStatusChange={handleEditStatusChange}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handleOpenEditPopup={handleOpenEditPopup}
        />
      )}
    </div>
  );
};

export default RiderSetting;
